export const B_SB_OR_PRODUCT_TYPES = ['B', 'SB', 'OR'];
export const FG_2FG_PRODUCT_TYPES = ['FG', '2FG'];

const roundCurrency = (value) => Math.round(value * 100) / 100;

const collectPricedLines = (sizeDetails) => {
  const pricedLines = [];

  for (const detail of sizeDetails) {
    const productType = String(detail?.product_type || '').trim().toUpperCase();
    const parsedQuantity = Number(detail?.quantity);
    const quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 0;
    if (!quantity) continue;

    if (B_SB_OR_PRODUCT_TYPES.includes(productType)) {
      pricedLines.push({ productGroup: 'b_sb_or', quantity });
    } else if (FG_2FG_PRODUCT_TYPES.includes(productType)) {
      pricedLines.push({ productGroup: 'fg_2fg', quantity });
    }
  }

  return pricedLines;
};

/**
 * Fixed: commission = order amount − (rate × qty) per product group.
 * Percentage: commission = order amount × (rate / 100), allocated by qty per product group.
 */
export function resolveVendorCommission(vendor, sizeDetails, orderAmount = 0) {
  if (!vendor || !Array.isArray(sizeDetails) || !sizeDetails.length) {
    return null;
  }

  const pricedLines = collectPricedLines(sizeDetails);
  if (!pricedLines.length) {
    return null;
  }

  const paymentBase = Number(orderAmount) || 0;
  const commissionType = vendor.commission_type === 'percentage' ? 'percentage' : 'fixed';
  const totalQuantity = pricedLines.reduce((sum, line) => sum + line.quantity, 0);
  if (totalQuantity <= 0 || paymentBase <= 0) {
    return null;
  }

  if (commissionType === 'fixed') {
    let vendorShare = 0;
    for (const line of pricedLines) {
      const rate = line.productGroup === 'b_sb_or'
        ? Number(vendor.b_sb_or_selling_price ?? 0)
        : Number(vendor.fg_2fg_selling_price ?? 0);
      vendorShare += rate * line.quantity;
    }
    return roundCurrency(paymentBase - vendorShare);
  }

  let commission = 0;
  for (const line of pricedLines) {
    const rate = line.productGroup === 'b_sb_or'
      ? Number(vendor.b_sb_or_selling_price ?? 0)
      : Number(vendor.fg_2fg_selling_price ?? 0);
    const linePaymentShare = paymentBase * (line.quantity / totalQuantity);
    commission += linePaymentShare * (rate / 100);
  }

  return roundCurrency(commission);
}

export function formatVendorRate(value, commissionType) {
  const numeric = Number(value ?? 0);
  if (commissionType === 'percentage') {
    return `${numeric}%`;
  }
  return numeric.toLocaleString('en-IN');
}

export function getVendorRateLabel(commissionType, productGroup) {
  const groupLabel = productGroup === 'b_sb_or' ? 'B/SB/OR' : 'FG/2FG';
  if (commissionType === 'percentage') {
    return `${groupLabel} Commission (%)`;
  }
  return `${groupLabel} Rate (₹/unit)`;
}
